import axios from 'axios'
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.axios.interceptors.request.use((config) => {
    try {
        const lang = localStorage.getItem('lang') || document.documentElement.lang || 'en'

        // Ensure headers exist and set Accept-Language (kept for compatibility)
        config.headers = config.headers || {}
        if (!config.headers['Accept-Language']) {
            config.headers['Accept-Language'] = lang
        }

        const method = (config.method || 'get').toLowerCase()

        if (method === 'get' || method === 'delete') {
            // For GET and DELETE requests, put lang in query params
            config.params = config.params || {}
            if (typeof config.params.lang === 'undefined') {
                config.params.lang = lang
            }
        } else if (method === 'post' || method === 'put') {
            // For POST and PUT requests, put lang in request body
            if (config.data == null) {
                config.data = { lang }
            } else if (config.data instanceof FormData) {
                if (!config.data.has('lang')) {
                    config.data.append('lang', lang)
                }
            } else if (typeof config.data === 'object') {
                if (typeof config.data.lang === 'undefined') {
                    config.data.lang = lang
                }
            } else {
                // Non-object payloads (e.g., raw string) are left unchanged to avoid breaking the request body
            }
        }
    } catch (e) {
        // Fail silently to avoid breaking requests if localStorage is unavailable
    }

    return config
})
